import { render } from "./InlineLoadingIndicator.vue?vue&type=template&id=a87d4e88&scoped=true"
import script from "./InlineLoadingIndicator.vue?vue&type=script&lang=ts"
export * from "./InlineLoadingIndicator.vue?vue&type=script&lang=ts"

import "./InlineLoadingIndicator.vue?vue&type=style&index=0&id=a87d4e88&lang=stylus&scoped=true"
script.render = render
script.__scopeId = "data-v-a87d4e88"

export default script